<template>
  <div id="brief">
    <div class="container">
      <div class="yuanda_img1">
        <img src="../../assets/images/yuanda_1.png" alt />
      </div>
      <div class="yuanda_img2">
        <img src="../../assets/images/yuanda_2.png" alt />
      </div>
      <div class="txt_box">
        <div class="yuanda_square"></div>
        <div class="yuanda_txt">
          <div class="home_item_content">
            <h6>about us</h6>
            <i></i>
            <h1>关于远达</h1>
            <div class="content">
              <p>陕西远达智能科技有限公司是一家集行业解决方案、自主软硬件研发、万物物联系统集成与服务于一体的高技术企业，是国内领先的物联网系统解决方案提供商，是深受客户信赖的万物物联技术服务提供商。</p>
              <p>有品质才有市场，有创新才有进步。公司以基于信息技术的创新能力为核心竞争力，通过技术创新、管理创新及商业模式创新，致力于围绕5G技术、智能安防、智能制造、智能运动监测、智能供应链定制、工业物联网、智慧城市、人工智能、智能家居、智慧医疗、智慧养老等领域解决方案的开发和应用，通过不断完善产品，筑建极具幸福感的智能生活新时代。</p>
              <p>未来，远达智能将继续完善研发服务标准化体系，融合前沿最新科学技术，让企业和个人在任何时候，任何地方，都能轻松享受万物物联带来的惊喜改变。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="home_item_content yuanda_env">
        <h6>Environment show</h6>
        <i></i>
        <h1>环境展示</h1>
      </div>
      <div class="environment_img">
        <div class="img_box">
          <div class="yuanda_img_box">
            <img src="../../assets/images/yuanda_3.png" alt />
            <div class="img_mask">
              <span>上班环境</span>
            </div>
          </div>
          <div class="yuanda_img_box">
            <img src="../../assets/images/yuanda_4.png" alt />
            <div class="img_mask">
              <span>办公环境</span>
            </div>
          </div>
          <div class="yuanda_img_box">
            <img src="../../assets/images/yuanda_6.png" alt />
            <div class="img_mask">
              <span>会议室</span>
            </div>
          </div>
          <div class="yuanda_img_box">
            <img src="../../assets/images/yuanda_7.png" alt />
            <div class="img_mask">
              <span>休息区域</span>
            </div>
          </div>
        </div>
        <div class="big_img_box">
          <img src="../../assets/images/yuanda_5.png" alt />
          <div class="img_mask">
            <span>办公室</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#brief {
  .yuanda_env {
    margin-top: 120px;
    margin-bottom: 40px;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    height: 800px;
    .environment_img {
      display: flex;

      .img_box {
        font-size: 0;
        display: flex;
        flex-wrap: wrap;
        width: 54%;
        .yuanda_img_box {
          position: relative;
          // width: 50%;
          &:hover .img_mask {
            display: block;
          }
          .img_mask {
            position: absolute;
            left: 0;
            bottom: 10px;
            height: 60px;
            width: 97%;
            background-color: rgba(0, 9, 94, 0.11);
            display: none;
            z-index: 100;
            line-height: 60px;
            padding-left: 20px;
            span {
              color: #fff;
              font-size: 20px;
            }
          }
        }
        img {
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
      .big_img_box {
        height: 630px;
        width: 46%;
        &:hover .img_mask {
          display: block;
        }
        .img_mask {
          position: absolute;
          bottom: 28px;
          height: 60px;
          width: 46.5%;
          background-color: rgba(0, 9, 94, 0.18);

          display: none;
          z-index: 100;
          line-height: 60px;
          padding-left: 20px;
          span {
            color: #fff;
            font-size: 20px;
          }
        }
      }
    }
    .home_item_content {
      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
      .content {
        margin-top: 40px;
        text-indent: 2em;
        font-size: 14px;
        line-height: 24px;
      }
    }
    .yuanda_img1 {
      position: absolute;
      left: -340px;
    }
    .yuanda_img2 {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .txt_box {
      position: relative;
      .yuanda_txt {
        width: 720px;
        height: 465px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 10px 20px rgba(0, 9, 94, 0.11);
        border-radius: 5px;
        margin: 0 auto;
        position: relative;
        top: 168px;
        z-index: 100;
        padding: 60px;
      }
      .yuanda_square {
        width: 60px;
        height: 60px;
        background: rgba(38, 172, 255, 1);
        border: 4px solid rgba(38, 172, 255, 1);
        position: absolute;
        top: 137px;
        right: 210px;
      }
    }
  }
}
</style>